import React from 'react';
import styles from 'src/components/star-grid/components/styles/ReportVersionSelector.module.scss';

export const VersionPickerIcon: React.FC<{ readonly kind: 'live' | 'tagged' }> = ({ kind }) => (
  <svg className={styles.choiceGlyph} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    {kind === 'live' && <path d="M2 12h5l3-7 4 14 3-7h5" />}
    {kind === 'tagged' && (
      <>
        <path d="M3 3h8l10 10-8 8L3 11Z" />
        <circle cx="7.5" cy="7.5" r="1" />
      </>
    )}
  </svg>
);
